module.exports = __webpack_public_path__ + "static/img/0402_04.aa0f40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_04.png
// module id = cGM3
// module chunks = 1